var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.226 5.688h3.294c.095 0 .183.045.236.126l.668.998h-5.098l.668-.998a.287.287 0 0 1 .236-.127h-.004zm6.226 1.125-1.29-1.938A1.976 1.976 0 0 0 14.524 4h-3.298c-.657 0-1.272.33-1.638.875l-1.29 1.938H5.844A.842.842 0 0 0 5 7.655c0 .468.376.844.844.844h.408l.843 11.415A2.251 2.251 0 0 0 9.338 22h7.074c1.177 0 2.155-.91 2.243-2.085L19.498 8.5h.408a.842.842 0 0 0 .844-.844.842.842 0 0 0-.844-.843H17.452zm.355 1.687-.836 11.292a.561.561 0 0 1-.563.52h-7.07a.566.566 0 0 1-.562-.52L7.943 8.5h9.864z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteTrash);
export default __webpack_public_path__ + "static/media/icon-delete-trash.5cfa0931.svg";
export { ForwardRef as ReactComponent };